<template>
  <div>
      <h1 style="display: none">Programa HuellaChile logra el reconocimiento del Ministerio del Medio Ambiente</h1>
      <div class="md-layout md-head-water" >
        <div class="md-layout-item md-small-size-100 mt-4" >
            <h1 class="calcHead head-sellos" style="margin-bottom: 2px !important; margin-top: 15px !important;color: #008c76;"> VERIFICACIÓN PROGRAMA </h1>
            <h1 class="calcHead head-sellos" style="margin-top: 2px !important; color: #00478a;">HUELLACHILE</h1>
        </div>
        <div class="md-layout-item right-side-head md-small-size-100 md-size-40" style="position: relative;">
            <img src="@/assets/huella.png" alt="Huella" srcset="" class="head-right-image-seil" >
        </div>
      </div>
      <div style="background-color:#008c76; text-align: justify; padding-bottom: 4vw; ">
          <div class="huella-detail md-layout">
              <div class="md-layout-item md-size-65 md-small-size-100">
                  <p>HuellaChile es una iniciativa que busca fomentar la cuantificación, reporte y gestión de las emisiones de GEI corporativa en el ámbito público y privado. </p>
                    <p>
                    Esta iniciativa tiene su origen en el Ministerio del Medio Ambiente y cuenta con el apoyo y financiamiento de la Comisión Europea, el Gobierno de Alemania y el Gobierno de Australia. Este programa entrega reconocimientos a las organizaciones participantes, los que se dividen en 4 niveles, que van desde la cuantificación de huella de carbono hasta la declaración de excelencia.
                    </p>
              </div>
              <div class="md-layout-item">
                  
              </div>
              
          </div>
          <div class="md-layout sellos-huella-seccion">
              
              <div class="md-layout-item md-small-size-100">
                   <img src="@/assets/buenas-practicas.png" id="buenasPracticas" alt="Buenas practicas" srcset="" width="90%" style="margin-left: 4rem;">
              </div>
              <div class="md-layout-item md-small-size-100">
                    <div class="wp_huella" > 
                        <a id="u26208" target="_blank"  href="https://api.whatsapp.com/send?phone=56971654429&amp;text=Me%20gustar%C3%ADa%20tener%20m%C3%A1s%20informaci%C3%B3n%20acerca%20de%20HuellaChile%20" @click="handleClick">
                            <p style="text-align: center; color: white; font-size: 1.7vw; line-height: 1.28;" > Para asesoría inmediata <br /> <strong style="color: white">presiona aquí</strong> </p>
                            <span class="circle circle-wp" >
                                <img src="@/assets/wp.svg" alt="Logo" srcset="" >
                            </span>
                        </a>
                    </div>
                    
              </div>
          </div>
         
          
          
      </div>
      <div class="md-layout">
          <div class="md-layout-item left-huella-side">
          </div>
          <div class="md-layout-item md-size-55 md-small-size-100 right-side-huella">
              <span class="circle circle-mano">
                  <img src="@/assets/mundo_green.png" alt="Mundo verde" srcset="">
                </span>
              <h1>Green Solutions</h1>
              <p>Green Solutions entrega toda su experiencia a organizaciones para que puedan participar exitosamente en el Programa Huella Chile.</p>
              <span class="circle circle-mundo">
                  <img src="@/assets/mano.png" alt="Mano" srcset="">
                </span>
              <h2>Servicios</h2>
                <p> <strong>Registro </strong> en el sistema de ventanilla única</p>
                <p> <strong>Acompañamiento</strong>  para el mejor uso de la plataforma HuellaChile</p>
                <p> <strong>Revisión </strong> de alcances y datos</p>
                <p> <strong>Elaboración</strong> de informes</p>
                <p> <strong>Verificación</strong>  de la huella de carbono</p>
                <p> <strong>Obtención</strong>  de reconocimientos del Ministerio del Medio Ambiente</p>
                <p> <strong>Cumplimiento</strong>  con exigencias de licitaciones públicas. </p>
                <div class="tel_huella" > 
                        <a id="u26209" href="tel:+56971654429" data-rel="external">
                            <p style="text-align: center; font-size: 1.7vw; line-height: 1.28;" > Para asesoría inmediata <br /> <strong >presiona aquí</strong>  </p>
                             
                            <span class="circle circle-tel" >
                                <img src="@/assets/phone-call.svg" alt="Llamar" srcset="" >
                            </span>
                           <p style="text-align: center; font-size: 1.7vw; line-height: 10; font-weight: bold" >+56 971654429</p>
                        </a>
                </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Programa HuellaChile postula a los sellos de  cuantificación, reducción neutralización y excelencia',
        meta: [
            { name: 'description', content: 'Se parte del Programa HuellaChile | Green Solutions. Respaldado por el Ministerio del Medio Ambiente. Contribuye a la lucha contra el cambio climático. Contáctanos para construir un futuro sostenible y reducir tu impacto ambiental.' }
        ]
    },
    methods: {
        handleClick() {
            gtag( 'event', 'Click',{
                event_category: 'Whatsapp',
                event_label: 'Whatsapp',
                value: 0
            })
        }
    }

}
</script>

<style>
.huella-detail {
    background-color:#008c76;
    color: #ffffff;
    padding: 4rem 0 4rem 4rem;
}
.huella-detail p {
    font-size: 1.5vw;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.52;
    letter-spacing: -0.66px;
    color: #ffffff;
}
.circle-mano {
    position: absolute;
    left: -8%;
    top: 7%;
}
.circle-mundo {
    position: absolute;
    left: -8%;
    top: 31%;
}
.md-cuantificate {
    width: 15rem;
    height: 3rem !important;
    border-radius: 52px !important;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #707070 !important;
    color: #ffffff !important;
}
.left-huella-side {
    background-image: url("../assets/huella-transparente.png");
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: center;
    background-size: contain;
}
.right-side-huella {
    padding: 2rem 10rem 2rem 4rem;
    text-align: justify;
    position: relative;
}
.right-side-huella h1 {
    font-size: 3vw;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.92;
    letter-spacing: normal;
    color: #00d371;
}
.right-side-huella h2 {
    font-size: 3vw;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.92;
    letter-spacing: normal;
}
.right-side-huella p {
    font-size: 1.5vw;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.54;
    letter-spacing: -0.56px;
    color: #565858;
}

.wp_huella {
    width: 50%; 
    margin: auto; 
    position: relative; 
    cursor: pointer
}

.wp_huella span.circle.circle-wp {
    position: absolute; 
    left: 39%; 
    padding: 1rem
}

.tel_huella {
     width: 50%; 
     position: relative; 
     cursor: pointer;
}
.circle-tel {
   position: absolute; 
   left: 35%; 
   padding: 1rem;
  
}
</style>
